export default __webpack_public_path__ + "static/media/service-logo-extra.eff5917e.png";